import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Search } from "lucide-react";
import { searchPlaces } from "../../api/geocode";
import { NeuInput } from "../../components/neu/Neu";

// بحث الأماكن بالعربية والإنجليزية (OpenStreetMap) مع اقتراحات فورية.
export const MapSearch = ({ onPick }) => {
  const { t, i18n } = useTranslation();
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const timer = useRef(null);

  useEffect(() => {
    clearTimeout(timer.current);
    if (query.trim().length < 2) {
      setResults([]);
      return;
    }
    timer.current = setTimeout(() => {
      searchPlaces(query, i18n.language).then(setResults).catch(() => setResults([]));
    }, 450);
    return () => clearTimeout(timer.current);
  }, [query, i18n.language]);

  return (
    <div className="relative z-10">
      <div className="relative">
        <NeuInput
          data-testid="map-search-input"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={t("map.searchPlaceholder")}
          className="pe-10"
        />
        <Search className="pointer-events-none absolute end-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      </div>
      {results.length ? (
        <ul
          className="absolute inset-x-0 top-full mt-2 max-h-60 overflow-y-auto rounded-2xl border border-border/60 bg-background p-2 shadow-neu"
          data-testid="map-search-results"
        >
          {results.map((r, index) => (
            <li key={`${r.latitude}-${r.longitude}-${index}`}>
              <button
                type="button"
                data-testid={`map-search-result-${index}`}
                className="w-full rounded-xl px-3 py-2 text-start text-xs font-semibold hover:shadow-neu-in"
                onClick={() => {
                  onPick(r);
                  setResults([]);
                  setQuery(r.label);
                }}
              >
                {r.label}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
};
